module.exports = __webpack_public_path__ + "static/images/home.3D45-Zr.svg";